import axios from "axios";

const conversationsAPI = axios.create({
  baseURL: "/api/conversations/",
});

export default conversationsAPI;
